import React from 'react';
import {useContextSelector} from 'use-context-selector';

import Loader from './Loader';
import FeedClientStatus from './FeedClientStatus';
import NavigationPrimary from './NavigationPrimary';
import NetworkConnectivityIndicator from './NetworkConnectivityIndicator';
import PreCacheFonts from './PreCacheFonts';

import ModalRef from '../util/ModalRef';
import {SessionContext} from '../context/SessionContext';

const LayoutComponents = (props) => {
    const modalVisible = useContextSelector(SessionContext, v => v[0].modalVisible);
    return <>
        <Loader>
            <FeedClientStatus />
        </Loader>
        <PreCacheFonts />
        <div
            style={
                {
                    position: `relative`,
                    display: `flex`,
                    width: `100%`,
                    height: `100%`,
                    flexDirection: `column`,
                    overflow: `auto`
                }
            }
            ref={ModalRef}
            className="bg-white"
        >
            <style>
                {`
                    .modal {
                        position: absolute;
                        overflow: auto;
                    }

                    .modal-backdrop {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: auto;
                        width: auto;
                    }
                `}
            </style>
            <Loader>
                <NavigationPrimary />
            </Loader>
            {props.children}
            {
                modalVisible ?
                    <Loader>
                        <NetworkConnectivityIndicator
                            className="d-flex justify-self-center"
                            hideOnline={true}
                            style={
                                {
                                    position: 'absolute',
                                    bottom: '0.5rem',
                                    zIndex: 1051
                                }
                            }
                        />
                    </Loader> :
                    null
            }
        </div>
    </>
}

export default LayoutComponents;
